import React from 'react';
import InfoMaterialContent from 'components/InfoMaterials/InfoMaterialContent';
import PropTypes from 'prop-types';

const InfoMaterials = props => (
  <div className={'container text-center'}>
    <InfoMaterialContent id={props.match.params.tagUrl} showTitle />
  </div>
);

InfoMaterials.propTypes = {
  // IN
  match: PropTypes.shape({
    params: PropTypes.shape({
      tagUrl: PropTypes.string.isRequired
    }).isRequired
  }).isRequired
};

export default InfoMaterials;



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutLandingPage/Content/InfoMaterials/InfoMaterials.js